import {TextField} from "@mui/material";
import useFetch from "../../../hooks/useFetch";
import CONFIG from "../../../config/_config";
import {useEffect} from "react";
import {useNotification} from "../../../store/admin/NotificationProvider";
import DialogModal from "../../_atoms/admin/DialogModal";

const CategoryFormModal = (props) => {
    const {response, makeRequest} = useFetch();
    const {showNotification} = useNotification()

    useEffect(() => {
        if (response){
            const notification = {
                open: true,
                type: 'error',
                message: "Errore durante la creazione della categoria"
            }

            if (response.state === 'success'){
                notification.type = 'success';
                notification.message = "Categoria creata con successo"
            }

            showNotification(notification);

            if (response.state === 'success') {
                const event = new CustomEvent('categoriesChanged',
                    {
                        bubbles: true,
                        cancelable: true
                    });
                window.dispatchEvent(event);

                props.onClose()
            }

        }
    }, [response]);

    return <>
        <DialogModal
            onClose={props.onClose}
            open
            fullWidth
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    const requestData = {
                        name: formJson.name,
                        description: formJson.description
                    };

                    if (!props.editMode) {
                        requestData.createNewCategory = 1;
                    } else {
                        requestData.position_index = props.category.position_index;
                        requestData.editCategory = 1;
                        requestData.id = props.category.id;
                    }

                    makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', requestData);
                },
            }}
            title={!props.editMode ? 'Crea categoria' : 'Modifica categoria'}
            actions={[
                {
                    variant: 'outlined',
                    color: 'brGrey',
                    onClick: props.onClose,
                    label: 'Annulla'
                },
                {
                    variant: 'contained',
                    type: 'submit',
                    label: !props.editMode ? 'Crea' : 'Salva'
                }
            ]}
            >
            <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="name"
                label="Nome"
                type="text"
                defaultValue={(props.category && props.category.name) ? props.category.name : ''}
                fullWidth
                variant="standard"
            />
            <TextField
                margin="dense"
                id="description"
                name="description"
                label="Descrizione (opzionale)"
                type="text"
                defaultValue={(props.category && props.category.description) ? props.category.description : ''}
                fullWidth
                variant="standard"
                multiline
                rows={3}
            />
        </DialogModal>
    </>
}

export default CategoryFormModal;